module.exports = __webpack_public_path__ + "img/FF_Info_Game_6.5672a232.png";